<template>
  <div class="card">
    <Message severity="info">No actions available for this type of Bot, yet.</Message>
  </div>
</template>
<script setup>
  import Message from 'primevue/message';
</script>
